import React, { useEffect, useState, useMemo } from "react";
import BasicTable from "../../maincomponent/reacttable/table";
import { patientlist } from "../../../text/apidata";
import axios from "axios";
import "../../style/page/tabs/appoinments.scss";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import noimage from "../../../assets/images/noimage.png";
import pdf from "../../../assets/images/pdf.png"
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { editdoctoruser, patientid, sidebar, pvphno, pbranch } from "../../redux/reducer/counterslice";

function SubAccount(props) {
    const doctor = useNavigate();
    const [tableheaderdata, settableheaderdata] = useState([]);
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(10);
    const [datacount, setdatacount] = useState();
    const [datasplit, setdatasplit] = useState(1);
    const phnodata = useSelector((state) => state.counter.pvphno);
    const branchdata = useSelector((state) => state.counter.pbranch);
    const patientviewid = useDispatch();
    const viewpatient = useNavigate();
    console.log(props.ismaster, "fjhfkj")
    var today = new Date();

    var it = convert(today);
    var gt = convert(today);
    const [range, setrange] = useState([gt, it]);
    function convert(str) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }
    const dropdownhandlechange = (e, ph, branchname) => {
        if (e) {
            // viewpatient("/PatientView");
            // enableditview("activedoctoredit");
            // dispatch(editdoctoruser("activedoctoredit"));
            window.location.reload();
            patientviewid(patientid(e));
            patientviewid(pvphno(ph));
            if (branchname = "VELACHERY") {
                patientviewid(pbranch("0"));
            } else if (branchname = "CHETPET") {
                patientviewid(pbranch("1"));
            } else {
                patientviewid(pbranch("2"));
            }

        }
    };

    useEffect(() => {
        axios({
            method: "get",
            url: patientlist,
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
            params: {
                page: dtpageindex,
                page_size: dtpagesize,
                search: phnodata,
                created_date_min: "2000-01-1",
                created_date_max: "2099-12-31",
                branch: branchdata,
            },
        })
            .then((res) => {
                console.log(res.data.data, 'fjhfkj')
                var masterdata = []
                if (props.ismaster) {
                    res.data.data.map((item) => {
                        if (item.is_master == false) {
                            masterdata.push(item)
                        }
                    })
                } else {
                    res.data.data.map((item) => {
                        if (item.is_master) {
                            masterdata.push(item)
                        }
                    })

                }
                settableheaderdata(masterdata)
                props.loaderchange("false");
            })
            .catch((error) => {
                console.log(error);
                props.loaderchange("false");
                // setdtPageindex(dtpageindex-1)
                props.popupalert("true");
                props.popuptext("No Data Available");
                setTimeout(() => {
                    props.popupalert("false");
                }, 2000);
            });
    }, [props.ismaster])

    const columns = useMemo(
        () => [
            {
                Header: "FirstName",
                accessor: "",
                Cell: (row) => {
                    // console.log(row.row.original.username)
                    return (
                        <>
                            {/* <span>
                    <div
                      style={{ marginTop: "3px" }}
                      data-tooltip-id="my-tooltip"
                      data-tooltip-content={String(row.row.original.first_name)}
                      onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                      className="doctorname"
                    >
                      {row.row.original.titles != null ? String(row.row.original.titles) + "." : "" +
                        String(row.row.original.first_name) +
                        " " +
                        String(row.row.original.last_name)}
                    </div>
                  </span> */}
                            <span style={{ display: "flex" }}>
                                <img
                                    style={{
                                        height: "2.5rem",
                                        width: "2.5rem",
                                        borderRadius: "50%",
                                    }}
                                    onClick={(e) => {
                                        window.open(
                                            row.row.original.profile_pic
                                                ? row.row.original.profile_pic
                                                : noimage
                                        );
                                    }}
                                    className="pointer"
                                    src={
                                        row.row.original.profile_pic
                                            ? row.row.original.profile_pic
                                            : noimage
                                    }
                                ></img>
                                <div
                                    style={{ marginTop: "9px", marginLeft: "10px" }}
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={
                                        // row.row.original.titles != null ? String(row.row.original.titles) + "." : "" +
                                        String(row.row.original.first_name) +
                                        " " +
                                        String(row.row.original.last_name)
                                    }
                                    onClick={(e) => dropdownhandlechange(row.row.original.id, row.row.original.phonenumber)}
                                    className="doctorname"
                                >
                                    {
                                        // row.row.original.titles != null ? String(row.row.original.titles) + "." : "" +
                                        String(row.row.original.first_name) +
                                        " " +
                                        String(row.row.original.last_name)}
                                </div>
                            </span>
                        </>
                    );
                },
            },
            // {
            //   Header: "LastName",
            //   accessor: "",
            //   Cell: (row) => {
            //     // console.log(row.row.original.username)
            //     return (
            //       <>
            //         <span>
            //           <div
            //             style={{ marginTop: "3px" }}
            //             data-tooltip-id="my-tooltip"
            //             data-tooltip-content={String(row.row.original.last_name)}
            //           >
            //             {String(row.row.original.last_name)}
            //           </div>
            //         </span>
            //       </>
            //     );
            //   },
            // },
            {
                Header: "Nationality",
                accessor: "",
                Cell: (row) => {
                    // console.log(row.row.original.username)
                    return (
                        <>
                            <span>
                                <div
                                    style={{ marginTop: "3px" }}
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={String(row.row.original.nationality)}
                                >
                                    {String(row.row.original.nationality)}
                                </div>
                            </span>
                        </>
                    );
                },
            },
            {
                Header: "Email",
                accessor: "",
                Cell: (row) => {
                    // console.log(row.row.original.username)
                    return (
                        <>
                            <span>
                                <div
                                    style={{ marginTop: "3px" }}
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={String(row.row.original.email)}
                                >
                                    {String(row.row.original.email)}
                                </div>
                            </span>
                        </>
                    );
                },
            },

            {
                Header: "PhoneNumber",
                accessor: "",
                Cell: (row) => {
                    // console.log(row.row.original.username)
                    return (
                        <>
                            <span>
                                <div
                                    style={{ marginTop: "3px" }}
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={String(row.row.original.phonenumber)}
                                >
                                    {String(row.row.original.phonenumber)}
                                </div>
                            </span>
                        </>
                    );
                },
            },
            {
                Header: "UHID",
                accessor: "",
                Cell: (row) => {
                    // console.log(row.row.original.username)
                    return (
                        <>
                            <span>
                                <div
                                    style={{ marginTop: "3px" }}
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={String(row.row.original.p_uhid)}
                                >
                                    {row.row.original.p_uhid == null
                                        ? "--"
                                        : row.row.original.p_uhid}
                                </div>
                            </span>
                        </>
                    );
                },
            },
            {
                Header: "Master",
                accessor: "",
                Cell: (row) => {
                    // console.log(row.row.original.username)
                    return (
                        <>
                            <span>
                                <div
                                    style={{ marginTop: "3px" }}
                                    data-tooltip-id="admin"
                                    data-tooltip-content={
                                        row.row.original.is_master == true ? "Yes" : "No"
                                    }
                                >
                                    {row.row.original.is_master == true ? "Yes" : "No"}
                                </div>
                            </span>
                        </>
                    );
                },
            },
            {
                Header: "Location Name",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={row.row.original.branch_display}
                            >
                                {row.row.original.branch_display}{" "}
                            </p>
                        </>
                    );
                },
            },
            {
                Header: "Last login",
                accessor: "",

                Cell: (row) => {
                    if (row.row.original.last_login != null) {
                        const dateString = row.row.original.last_login;
                        const dateObject = new Date(dateString);

                        const hours = dateObject.getHours();
                        const minutes = dateObject.getMinutes();
                        const seconds = dateObject.getSeconds();
                        const amOrPm = hours >= 12 ? "PM" : "AM";
                        const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

                        const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

                        return (
                            <>
                                <p
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={`${formattedTime}`}
                                >
                                    {`${row.row.original.last_login.slice(0, 10) +
                                        "  " +
                                        formattedTime
                                        }`}
                                </p>
                            </>
                        );
                    } else {
                        return (
                            <p data-tooltip-id="my-tooltip" data-tooltip-content={"--"}>
                                {"--"}
                            </p>
                        );
                    }
                },
            },
            {
                Header: "Actions",
                accessor: "",
                // onChange: () => { dropdownhandlechange(e,row) },
                Cell: (row) => {
                    return (
                        <>
                            <button
                                type="button"
                                class="btn btn-danger btn-sm delete"
                                style={{ display: "flex", gap: "4px" }}
                                onClick={(e) => dropdownhandlechange(row.row.original.id, row.row.original.phonenumber, row.row.original.branch_display)}
                            >
                                <i
                                    onClick={(e) => dropdownhandlechange(row.row.original.id, row.row.original.phonenumber, row.row.original.branch_display)}
                                    class="bi bi-eye-fill"
                                ></i>{" "}
                                View
                            </button>
                        </>
                    );
                },
            },

        ],
        []
    );

    const pagesize = (arg) => {
        setdtPagesize(arg);
    };

    const pageindex = (arg) => {
        setdtPageindex(arg);
    };
    const handlechangedate = (name, value) => {
        // let data =value.slice(0, 10)
        if (value != null) {
            setrange([]);
            setTimeout(() => {
                setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
                setTimeout(() => {
                    console.log(value.slice(0, 10));
                }, 1000);
            }, 400);
        }
        // setcurrentdate(value.slice(0, 10));
        // let result = value.replaceAll('/','-');

        // console.log(currentdate)
    };
    const cleaningrange = () => {
        setrange([]);
    };

    const datachange = (e) => {
        if (datasplit == 0) {
            setdatasplit(1);
        } else {
            setdatasplit(0);
        }
    };
    return (
        <>
            <div className="maincontainer_appoinment">
                <div class="tab-content" id="nav-tabContent">
                    <div
                        class="tab-pane fade show active"
                        id="nav-home"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab"
                    >
                        {/* <div className="datepicker"> */}
                        {/* <DateRangePicker
                            getPopupContainer={trigger => trigger.parentElement}
                            placement="auto"
                            editable={false}
                            appearance="default"
                            size="lg"
                            placeholder="From - To"
                            style={{ width: 270, padding: 10 }}
                            onClean={(e) => cleaningrange(e)}
                            onChange={(e) => {
                                if (e != null) {
                                    e.forEach((newValue) => {
                                        var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                                        var localISOTime = new Date(newValue - tzoffset)
                                            .toISOString()
                                            .slice(0, -1);
                                        handlechangedate("validtill", localISOTime);
                                    });
                                }
                            }}
                        /> */}
                        {/* </div> */}
                        <div className="appoinment">
                            <div className="table-content-appoinment">
                                <div className="table-appoinment">
                                    <BasicTable
                                        columns={columns}
                                        data={tableheaderdata}
                                        pagesize={pagesize}
                                        pageindex={pageindex}
                                        dtpagesize={dtpagesize}
                                        dtpageindex={dtpageindex}
                                        datacount={datacount}
                                    />
                                </div>
                            </div>
                        </div>
                        <ReactTooltip
                            id="appoinment"
                            arrowColor="transparent"
                            place="bottom-start"
                            delayShow={200}
                            style={{
                                backgroundColor: "#707070",
                                fontSize: "10px",
                                textAlign: "center",
                                padding: "5px",
                                fontWeight: 400,
                            }}
                        />
                    </div>
                    <div
                        class="tab-pane fade"
                        id="nav-profile"
                        role="tabpanel"
                        aria-labelledby="nav-profile-tab"
                    >
                        ...
                    </div>
                </div>
            </div>
        </>
    );
}

export default SubAccount;
